import { buttonRecipe } from './button.recipe';
import { textRecipe } from './text.recipe';

export const recipes = {
  button: buttonRecipe,
  text: textRecipe,
};
